/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { Link } from 'react-router-dom';
import { string, object, bool, number, node, func } from 'prop-types';
import { connect } from 'react-redux';

// import RigthArrowIcon from '@material-ui/icons/KeyboardArrowRight';
import PersonIcon from '@material-ui/icons/AccountCircle';
import TrackIcon from '@material-ui/icons/TrackChanges';
import TruckIcon from '@material-ui/icons/LocalShipping';
import BubbleChatIcon from '@material-ui/icons/QuestionAnswer';
import MapIcon from '@material-ui/icons/Room';
import withStyles from '@material-ui/core/styles/withStyles';

import memberDucks from '../../../../../../../../state/ducks/Member/ducks';
import { ducks as checkoutDucks } from '../../../../../../../../state/ducks/Checkout';
import { actions as tagManagerActions } from '../../../../../../../../state/ducks/TagManager';

const LINKSTYLE_NORMAL = 'Normal';
const LINKSTYLE_ALTERNATE = 'Alternate';
const LINKSTYLE_DIVIDER = 'Divider';
// const LINKSTYLE_BUTTON = 'Button';    TODO
// const LINKSTYLE_WIDGET = 'Widget';    TODO

const {
    common: {
        commonSelectors: { getIsAuthenticatedStatus, getUserRole },
    },
} = memberDucks;

const { common: { commonSelectors: { getPassportSubscriptionStatus } } } = checkoutDucks;

const styles = (theme) => {
    const mobileMenuBG = theme && theme.palette && theme.palette.mobileMenuBG ? theme.palette.mobileMenuBG : null;
    return {
        toggleHeader: {
            color: `${theme.palette.linkMenu} !important`,
            boxSizing: 'border-box',
            display: 'flex',
            fontSize: '16px',
            textDecoration: 'none',
            position: 'relative',
            fontWeight: '300',
            padding: '12px 10px',
            width: '100%',
            backgroundColor: `${theme.palette.white} !important`,
        },
        toggleHeaderOpened: {
            color: `${theme.palette.linkMenu} !important`,
            boxSizing: 'border-box',
            display: 'flex',
            fontSize: '16px',
            textDecoration: 'underline',
            position: 'relative',
            fontWeight: '300',
            padding: '12px 10px',
            width: '100%',
            backgroundColor: `${theme.palette.white} !important`,
        },
        item: {
            width: '80%',
            display: 'inline-block',
            padding: '0',
        },
        itemOpened: {
            display: 'inline-block',
            padding: '0',
            borderBottom: `1px solid ${theme.palette.black}`,
        },
        link: {
            color: theme.palette.linkMenu,
            display: 'flex',
            alignItems: 'center',
            fontSize: '16px',
            textDecoration: 'none',
            position: 'relative',
            fontWeight: '400',
            height: 'auto',
            marginLeft: '0',
            width: '95%',
            padding: '0',
        },
        alternateStyleLink: {
            background: mobileMenuBG ? mobileMenuBG.nonProduct : null,
            display: 'block',
            fontSize: '16px',
            textDecoration: 'none',
            position: 'relative',
            fontWeight: '400',
            height: 'auto',
            marginLeft: '0',
            width: '100%',
            padding: '10px',
            '& a': {
                color: theme.palette.white,
            },
        },
        rightIcon: {
            position: 'absolute',
            right: '24px',
            top: '4px',
        },
        spriteImgIcon: {
            paddingRight: '5px',
        },
        plaSpriteImgIcon: {
            height: '20px',
            width: '20px',
            marginRight: '5px',
            textAlign: 'center',
        },
        divider: {
            boxSizing: 'border-box',
            height: '20px',
            display: 'flex',
            flexDirection: 'row',
            backgroundColor: 'transparent',
            marginLeft: '10px',
        },
    };
};

const getDataTestAttribute = (brandId, url, linkStyle, itemLabel) => {
    const link = url.split('/');
    let dataTest = '';
    if (linkStyle === LINKSTYLE_ALTERNATE) {
        const toSnakeCase = itemLabel
            .split(' ')
            .join('-')
            .toLowerCase();
        dataTest = `${'nav-menu-link-'}${toSnakeCase}`;
    } else if (link[link.length - 1].indexOf('?') >= 0) {
        const removingParams = link[link.length - 1].split('?');
        dataTest = `${removingParams[0]}${'-'}${brandId}${'-'}${'link'}`;
    } else {
        dataTest = `${link[link.length - 1]}${'-'}${brandId}${'-'}${'link'}`;
    }
    return dataTest;
};

const getStyleObject = (menuItem) => {
    if (menuItem.color) {
        return { color: menuItem.color };
    }
    return null;
};

const MenuLink = ({
    itemLink,
    classes,
    tabIndex,
    children,
    handleClose,
    brandId,
    linkStyle,
    itemLabel,
    menu,
    trackEvent,
}) => {
    try {
        if (itemLink.indexOf('://') !== -1) {
            return (
                <a href={itemLink} className={classes.link} tabIndex={tabIndex}>
                    {children}
                </a>
            );
        }
    } catch (ex) {
        console.error('Failed to build menu link.', ex);
    }

    if (itemLink !== 'none') {
        return (
            <Link
                data-test={getDataTestAttribute(brandId, itemLink, linkStyle, itemLabel)}
                onClick={(e) => {
                    handleClose(e);
                    trackEvent({
                        eventName: 'feature_interaction',
                        eventCategory: 'Mobile Nav',
                        eventAction: 'Click',
                        eventLabel: `${menu.category} - ${itemLabel}` || '',
                    });
                }}
                to={itemLink}
                className={classes.link}
                tabIndex={tabIndex}
                style={getStyleObject(menu)}
                target={itemLink.indexOf('greenhouse')  > -1 ? '_blank' : ''}
            >
                {children}
            </Link>
        );
    }

    return children;
};

MenuLink.propTypes = {
    itemLink: string.isRequired,
    classes: object.isRequired,
    tabIndex: number.isRequired,
    children: node.isRequired,
    handleClose: func.isRequired,
    brandId: string.isRequired,
    linkStyle: string.isRequired,
    itemLabel: string.isRequired,
    menu: object.isRequired,
    trackEvent: func.isRequired,
};

const NavMenuItem = ({
    itemLabel,
    itemLink,
    classes,
    icon,
    hasSubmenu,
    tabIndexMenu,
    isAuthenticated,
    handleClose,
    linkStyle,
    userRole,
    isPassportInCart,
    brandId,
    menu,
    isOpen,
    trackEvent,
}) => {
    /* eslint object-curly-newline: "off" */
    const iconPresets = {
        person: PersonIcon,
        target: TrackIcon,
        truck: TruckIcon,
        bubble_chat: BubbleChatIcon,
        marker: MapIcon,
    };

    if (linkStyle === LINKSTYLE_DIVIDER) {
        return <div className={classes.divider} tabIndex="-1" />;
    }

    if ((itemLabel === 'Login' && isAuthenticated) || (itemLabel === 'Logout' && !isAuthenticated)) {
        return null;
    }

    if (
        itemLabel.includes('Join Passport')
    && ((userRole === 'P' && isAuthenticated) || isPassportInCart)
    ) {
        return null;
    }

    // icon should be "[[preset]]" or image url
    let SpriteImgIcon = null;
    if (icon) {
        const match = icon.match(/^\[\[(\S+)\]\]$/); // e.g.  '[[person]]'
        if (match) {
            SpriteImgIcon = iconPresets[match[1]];
            SpriteImgIcon = SpriteImgIcon ? <SpriteImgIcon className={classes.spriteImgIcon} /> : null;
        } else if (brandId === 'pla') {
            SpriteImgIcon = <div className={classes.plaSpriteImgIcon}><img alt="menu item icon" src={icon} /></div>;
        } else {
            SpriteImgIcon = <img alt="menu item icon" src={icon} />;
        }
    }

    // TODO: replace this kludgery with feature flag
    if (itemLabel === 'Welcome') {
        return null;
    }

    // TODO:  button formatting when LINKSTYLE_BUTTON

    if (hasSubmenu) {
        return (
            <div
                className={
                    linkStyle === LINKSTYLE_ALTERNATE ? classes.alternateStyleLink : classes.toggleHeader
                }
                tabIndex={tabIndexMenu}
            >
                {SpriteImgIcon}
                <span className={isOpen ? classes.itemOpened : classes.item}>{itemLabel}</span>
            </div>
        );
    }

    return (
        <div
            className={
                linkStyle === LINKSTYLE_ALTERNATE ? classes.alternateStyleLink : classes.toggleHeader
            }
        >
            {SpriteImgIcon}
            <MenuLink
                brandId={brandId}
                itemLabel={itemLabel}
                linkStyle={linkStyle}
                itemLink={itemLink}
                classes={classes}
                tabIndex={tabIndexMenu}
                handleClose={handleClose}
                menu={menu}
                trackEvent={trackEvent}
            >
                <span className={classes.item}>{itemLabel}</span>
            </MenuLink>
        </div>
    );
};

const getBrandId = (state) => state.ui.brandId.toLowerCase();

function mapStateToProps(state) {
    return {
        isAuthenticated: getIsAuthenticatedStatus(state),
        userRole: getUserRole(state),
        brandId: getBrandId(state),
        isPassportInCart: getPassportSubscriptionStatus(state),
    };
}

const mapDispatchToProps = {
    trackEvent: tagManagerActions.trackEvent,
};

NavMenuItem.propTypes = {
    itemLabel: string.isRequired,
    itemLink: string.isRequired,
    classes: object.isRequired,
    icon: string,
    hasSubmenu: bool,
    tabIndexMenu: number,
    isAuthenticated: bool.isRequired,
    handleClose: func.isRequired,
    linkStyle: string,
    userRole: string.isRequired,
    isPassportInCart: bool.isRequired,
    brandId: string.isRequired,
    menu: object.isRequired,
    isOpen: bool.isRequired,
    trackEvent: func.isRequired,
    // brand: object,
};

NavMenuItem.defaultProps = {
    icon: '',
    hasSubmenu: false,
    tabIndexMenu: -1,
    linkStyle: LINKSTYLE_NORMAL,
    // brand: {},
};

const NavMenuItemStyled = withStyles(styles)(NavMenuItem);
export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(NavMenuItemStyled);
